export default {
    name: 'A2',
    margin: '24px 0'
  }